import React from 'react'

import Container from 'components/common/Container'
import GenerationStyles from 'components/GenerationStyles'
import { Style, Suggestion } from 'types/Generation'
import { EnhancementResponse } from 'types/Response'
import RequestGenerationContainer from '../../../RequestGenerationContainer'

import c from './IdleStage.module.scss'

interface IdleStageProps {
  text: string
  suggestions?: Suggestion[]
  styles?: Style[]
  chosenStyle: string | undefined
  onTextChange: (newText: string) => void
  onProcessingStart: () => void
  onExampleClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  onStyleClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  imageUrl: string | null | undefined
  generationHistoryData?: EnhancementResponse[]
  chosenHistory?: number
  handleHistoryClick: (id: number | undefined) => void
  onImageChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onDeleteImage: () => void
}

function IdleStage({
  text,
  suggestions = [],
  styles = [],
  chosenStyle,
  onTextChange,
  onProcessingStart,
  onExampleClick,
  onStyleClick,
  imageUrl,
  generationHistoryData = [],
  chosenHistory = undefined,
  handleHistoryClick,
  onImageChange,
  onDeleteImage,
}: IdleStageProps) {
  const isDisabledButton = text.length === 0 || (!imageUrl && !chosenHistory)

  return (
    <Container flex>
      <div className={c.content}>
        <RequestGenerationContainer
          photoSelectionVisible
          promptTipsVisible
          imageUrl={imageUrl}
          generationHistoryData={generationHistoryData}
          chosenHistory={chosenHistory}
          handleHistoryClick={handleHistoryClick}
          onImageChange={onImageChange}
          onDeleteImage={onDeleteImage}
          suggestions={suggestions}
          videoText={text}
          onVideoTextChange={onTextChange}
          onProcessingStart={onProcessingStart}
          onExampleClick={onExampleClick}
          generationVideoTextAreaVisible
          isDisabledButton={isDisabledButton}
        />
        <GenerationStyles
          chosenStyle={chosenStyle}
          styles={styles}
          onStyleClick={onStyleClick}
        />
      </div>
    </Container>
  )
}

export default IdleStage
